export function RecordPropertyLoading () {
  return (
    <div className="py-1">
      <span className='text-xs font-semibold'>Calculating...</span>
      <span className="loading loading-ring text-primary loading-xs ml-2" />
    </div>
  )
}
